/* global REACT_APP_PUBLIC_FEATURE_FLAGS */
const flags: string[] = typeof REACT_APP_PUBLIC_FEATURE_FLAGS !== 'undefined' ? REACT_APP_PUBLIC_FEATURE_FLAGS : [];

export const ENABLE_ORDERS_V2 = flags.includes('orders-v2');
export const ENABLE_COMMERCE_V2 = flags.includes('commerce-v2');
export const ENABLE_DELIVERY_V2 = flags.includes('delivery-v2');
export const ENABLE_HORARIOS_V2 = flags.includes('horarios-v2');
export const ENABLE_AJUSTES_V2 = flags.includes('ajustes-v2');
export const ENABLE_MENU_V2 = flags.includes('menu-v2');
// Rollout del chat de soporte Paulina. El build-flag 'agent-chat' está ON en TODOS los ambientes
// (desde el commit 65003106, 2026-06-16) y el experimento 'agent-chat-rollout-2026q2' está al 100%
// (GA) → el rollout ofrece Paulina a TODOS los comercios, así que se monta para todos. El montaje ya
// no oculta a nadie; el único gate activo hoy es la proactividad/nudges (PAULINA_NUDGES_ENABLED en
// usePaulinaChat), no este flag.
export const ENABLE_AGENT_CHAT_ROLLOUT = flags.includes('agent-chat');
export const ENABLE_STATS_V2 = flags.includes('stats-v2');
// FR-28: ON → selector (ActivatePlanModal); OFF → Payment Link viejo.
export const ENABLE_PAYMENT_SELECTOR_V2 = flags.includes('payment-selector-v2');
// Smart Menu Onboarding (PR onboarding-smart-menu-v4): habilita el step skippable de
// upload multi-archivo dentro del wizard de onboarding y re-cablea la card
// "Configuración Inteligente" del Setup. OFF en prod hasta validar en pruebas.
export const ENABLE_SMART_MENU_ONBOARDING = flags.includes('smart-menu-onboarding');
// Reception gate (multisucursal): cuando está ON, el FE envía identidad de la conexión
// (id_comercio + can_see_other_branches) en el subscribe para que el backend pueda filtrar
// eventos por comercio. Default OFF: el mensaje de subscribe queda idéntico al actual
// (solo channelIds) y NO se altera la recepción de pedidos/tickets de ningún perfil.
export const ENABLE_RECEPTION_GATE = flags.includes('reception-gate');

// Resuelve si el build-flag de una feature de rollout está activo en esta build.
// El slug del flag coincide con feature.feature_key (MENU_FEATURE_KEY = 'menu-v2').
// Usado por useFeatureVersion para quedar INERTE (sin GET ni outbox) cuando la feature
// no está habilitada en la build (p.ej. menu-v2 OFF en prod) y así no generar GETs ni
// telemetría fallidos por toda la base antes de que api+panel+backoffice estén listos.
export const isFeatureBuildEnabled = (featureKey: string): boolean => flags.includes(featureKey);
